import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { logger } from '@/services/logger/logger';
import VerticalCentre from '@/components/verticalCentre/VerticalCentre';
import Loader from '@/components/loader/Loader';

import { CartProvider, useCartContext } from './CartContext';

const isNonProduction = import.meta.env.VITE_CLIENT === 'test';

function CartContainerInner({ children }: React.PropsWithChildren) {
  const { cartData, cartsLoadError } = useCartContext();

  const navigate = useNavigate();

  // Redirect to an error page if carts data (i.e. payments service) is erroring
  useEffect(() => {
    if (!cartsLoadError) {
      return;
    }
    const errorMessage = 'Error loading carts data';
    logger.error(errorMessage);

    if (isNonProduction) {
      console.error(errorMessage, cartsLoadError);
    }

    void navigate('/error', isNonProduction ? {
      state: {
        errorMessage,
        error: cartsLoadError
      }
    } : undefined);
  }, [cartsLoadError, navigate]);

  if (cartsLoadError) {
    return null;
  }

  // Normally (when carts data is loaded) display the application
  if (cartData) {
    return children;
  }

  // Show a loader while waiting for carts data to be ready
  return (
    <VerticalCentre>
      <Loader />
    </VerticalCentre>
  );
}

function CartContainer({ children }: React.PropsWithChildren) {
  return (
    <CartProvider>
      <CartContainerInner>{children}</CartContainerInner>
    </CartProvider>
  );
}

export default CartContainer;
